// Shared override reason options for the bulk reassignment / bulk case assignment forms.
export const OVERRIDE_REASONS = [
  'UW going on leave',
  'UW deactivated',
  'Capacity rebalancing',
  'Authority limit insufficient',
  'Specialization mismatch',
  'Continuity correction',
  'Other',
];
